import styled from 'styled-components';

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  text-align: left;
`;

export const TooltipTitle = styled.span`
  display: block;
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.3;
  letter-spacing: -0.255px;
  color: ${({ theme }) => theme.color.pickledBluewood};
`;

export const TooltipMeta = styled.span`
  display: block;
  margin: 0 0 16px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: ${({ theme }) => theme.color.baliHai};
`;

export const TooltipHint = styled.span`
  display: block;
  font-weight: 500;
  font-size: 11px;
  line-height: 14px;
  color: ${({ theme }) => theme.color.brightTurquoise};
`;

export const TooltipStatus = styled.span<{ $tone?: 'warning' | 'muted' }>`
  display: block;
  font-weight: 600;
  font-size: 11px;
  line-height: 14px;
  color: ${({ theme, $tone }) =>
    $tone === 'warning' ? theme.color.koromiko : theme.color.casper};
`;
